import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public endpoints
export const getProducts = () => API.get('/api/products');
export const getTestimonials = () => API.get('/api/testimonials');
export const getActiveVideo = () => API.get('/api/videos/active');
export const trackOrder = (orderNumber, email) => API.get(`/api/orders/track/${orderNumber}`, { params: { email } });
export const submitStory = (data, beforePhoto, afterPhoto) => {
  const formData = new FormData();
  formData.append('customer_name', data.customer_name);
  formData.append('hair_type', data.hair_type || '');
  formData.append('rating', data.rating);
  formData.append('testimonial_text', data.testimonial_text);
  formData.append('results_summary', data.results_summary || '');
  if (beforePhoto) formData.append('before_photo', beforePhoto);
  if (afterPhoto) formData.append('after_photo', afterPhoto);
  return API.post('/api/testimonials/submit', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// Admin auth
export const adminLogin = (email, password) => API.post('/api/admin/login', { email, password });
export const adminLogout = () => API.post('/api/admin/logout');

// Admin products
export const getAdminProducts = () => API.get('/api/products');
export const createProduct = (data) => API.post('/api/admin/products', data);
export const updateProduct = (id, data) => API.put(`/api/admin/products/${id}`, data);
export const deleteProduct = (id) => API.delete(`/api/admin/products/${id}`);
export const uploadProductImage = (id, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return API.post(`/api/admin/products/${id}/images`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// Admin orders
export const getAdminOrders = () => API.get('/api/admin/orders');
export const updateOrderStatus = (id, status) => API.put(`/api/admin/orders/${id}/status`, null, { params: { status } });

// Admin testimonials
export const getAdminTestimonials = () => API.get('/api/admin/testimonials');
export const createTestimonial = (data) => API.post('/api/admin/testimonials', data);
export const updateTestimonial = (id, data) => API.put(`/api/admin/testimonials/${id}`, data);
export const deleteTestimonial = (id) => API.delete(`/api/admin/testimonials/${id}`);

// Admin videos
export const getAdminVideos = () => API.get('/api/admin/videos');
export const uploadVideo = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return API.post('/api/admin/videos/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const activateVideo = (id) => API.put(`/api/admin/videos/${id}/activate`);
export const deleteVideo = (id) => API.delete(`/api/admin/videos/${id}`);

// Admin analytics
export const getSalesAnalytics = () => API.get('/api/admin/analytics/sales');

// Site Content CMS
export const getSiteContent = () => API.get('/api/site-content');
export const updateSiteContent = (data) => API.put('/api/admin/site-content', data);
export const uploadSiteImage = (file, section) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('section', section);
  return API.post('/api/admin/site-content/upload-image', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// Newsletter
export const subscribeNewsletter = (email, ref) => API.post('/api/newsletter/subscribe', { email, ref });
export const getNewsletterSubscribers = () => API.get('/api/admin/newsletter/subscribers');
export const getNewsletterCount = () => API.get('/api/newsletter/count');
export const sendNewsletterAnnouncement = () => API.post('/api/admin/newsletter/send-announcement', {});
export const sendNewsletterTemplate = (templateId) => API.post('/api/admin/newsletter/send-template', { template_id: templateId });

// Email Templates
export const getEmailTemplates = () => API.get('/api/admin/email-templates');
export const createEmailTemplate = (data) => API.post('/api/admin/email-templates', data);
export const updateEmailTemplate = (id, data) => API.put(`/api/admin/email-templates/${id}`, data);
export const deleteEmailTemplate = (id) => API.delete(`/api/admin/email-templates/${id}`);

// Quiz
export const recordQuizResult = (data) => API.post('/api/quiz/complete', data);
export const getQuizAnalytics = () => API.get('/api/admin/analytics/quiz');

// Stripe Payments
export const createCheckout = (lookupKey, quantity, originUrl) => API.post('/api/payments/checkout', { lookup_key: lookupKey, quantity, origin_url: originUrl });
export const createCartCheckout = (items, originUrl) => API.post('/api/payments/cart-checkout', { items, origin_url: originUrl });
export const getPaymentStatus = (sessionId) => API.get(`/api/payments/status/${sessionId}`);

// Referrals
export const getReferralAnalytics = () => API.get('/api/admin/analytics/referrals');
